import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatToLocal } from './format-to-local';

@NgModule({
  declarations: [
    FormatToLocal,
  ],
  imports: [CommonModule],
  exports: [
    FormatToLocal,
  ]
})
export class PipesModule {}